<template>
  <router-view/>
</template>

<script>
import 'bootstrap';

export default {
  name: 'App',
}
</script>

<style>
@import '~bootstrap/dist/css/bootstrap.css';
@import "~choices.js/public/assets/styles/choices.min.css";
@import "main.css";
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap');


#app {
  font-family: "Open Sans", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}

</style>
